module.exports = __webpack_public_path__ + "static/img/hh.fbc44a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/hh.png
// module id = 3eiy
// module chunks = 0